import { render, staticRenderFns } from "./IndividualCompetence.vue?vue&type=template&id=345a72e4&scoped=true&lang=pug"
import script from "./IndividualCompetence.vue?vue&type=script&lang=js"
export * from "./IndividualCompetence.vue?vue&type=script&lang=js"
import style0 from "./IndividualCompetence.vue?vue&type=style&index=0&id=345a72e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345a72e4",
  null
  
)

export default component.exports